import jQuery from 'jquery';
const $ = jQuery;
// var test = 0; 
// let sum = test + 3;
//console.log('Test log');
// $( function(){
// 
//   $('body').prepend('Hej från global jQuery');
  $('.js-search-toggle').click( (event) => {
    const target = event.currentTarget;
    $(target).next().toggle();
  })
  $('.js-menu-toggle').click( (event) => {
    const target = event.currentTarget;
    $(target).parent().next().toggleClass('hidden');
  })
  $('.language-switcher .icon').click( (event) => {
    $('.language-switcher .menu').toggleClass('hidden');
  })

// });
